import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Logo } from '../ui/Logo';
import { MenuIcon, XIcon } from 'lucide-react';
const navItems = [{
  name: 'Home',
  path: '/'
}, {
  name: 'Platform',
  path: '/platform'
}, {
  name: 'Solutions',
  path: '/solutions'
}, {
  name: 'Pricing',
  path: '/pricing'
}, {
  name: 'About',
  path: '/about'
}, {
  name: 'FAQs',
  path: '/faqs'
}, {
  name: 'Contact',
  path: '/contact'
}];
export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };
  return <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-78">
      <div className="container-custom py-4" data-id="element-79">
        <div className="flex justify-between items-center" data-id="element-80">
          <Logo data-id="element-81" />
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-1" data-id="element-82">
            {navItems.map(item => <Link key={item.name} to={item.path} className={`px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${location.pathname === item.path ? 'text-brand-teal' : 'text-brand-dark hover:text-brand-teal'}`} data-id="element-83">
                {item.name}
              </Link>)}
            <div className="ml-4 flex items-center space-x-2" data-id="element-84">
              <Link to="/signin" className="btn-ghost text-sm" data-id="element-85">
                Sign in
              </Link>
              <Link to="/trial" className="btn-primary text-sm" data-id="element-86">
                Start free trial
              </Link>
            </div>
          </nav>
          {/* Mobile menu button */}
          <button className="md:hidden text-brand-dark" onClick={toggleMobileMenu} data-id="element-87">
            {mobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-88" /> : <MenuIcon className="h-6 w-6" data-id="element-89" />}
          </button>
        </div>
        {/* Mobile Navigation */}
        {mobileMenuOpen && <nav className="md:hidden py-4 bg-white" data-id="element-90">
            <div className="flex flex-col space-y-2" data-id="element-91">
              {navItems.map(item => <Link key={item.name} to={item.path} className={`px-3 py-2 rounded-md text-base font-medium ${location.pathname === item.path ? 'text-brand-teal bg-brand-light' : 'text-brand-dark hover:bg-brand-light hover:text-brand-teal'}`} onClick={() => setMobileMenuOpen(false)} data-id="element-92">
                  {item.name}
                </Link>)}
              <div className="pt-4 flex flex-col space-y-2" data-id="element-93">
                <Link to="/signin" className="btn-ghost text-center" onClick={() => setMobileMenuOpen(false)} data-id="element-94">
                  Sign in
                </Link>
                <Link to="/trial" className="btn-primary text-center" onClick={() => setMobileMenuOpen(false)} data-id="element-95">
                  Start free trial
                </Link>
              </div>
            </div>
          </nav>}
      </div>
    </header>;
};